import { oz } from '@weft/utils';
import { IngestedEventSchema } from './ingested-event-schema';

export const MIN_EVENTS = 1;
export const MAX_EVENTS = 1000;

export const EventsPayloadSchema = oz.object({
  events: oz.array(IngestedEventSchema)
    .min(MIN_EVENTS)
    .max(MAX_EVENTS),
});

export type EventsPayload = oz.infer<typeof EventsPayloadSchema>;
